import React from "react";
import { useTranslation } from "react-i18next";
import AuthPage from "./AuthPage.jsx";

export default function ConfirmSignUpForm({
  email,
  code,
  setCode,
  onConfirm,
  onResend,
  onBack,
  error,
  notice,
  loading,
  resending,
}) {
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    onConfirm();
  };

  return (
    <AuthPage
      title={t("confirmationTitle")}
      subtitle={t("confirmationSubtitle")}
    >
      <p className="-mt-6 mb-6 break-all text-center font-medium text-slate-800">
        {email}
      </p>
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label
            htmlFor="confirmation-code"
            className="text-sm font-medium text-slate-700"
          >
            {t("verificationCode")}
          </label>
          <input
            id="confirmation-code"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength="6"
            value={code}
            onChange={(event) => setCode(event.target.value.replace(/\s/g, ""))}
            className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-center text-lg tracking-[0.35em] text-gray-900 shadow-sm outline-none transition focus:border-sky-600 focus:ring-2 focus:ring-sky-200"
            disabled={loading}
            required
          />
        </div>

        {error && (
          <p
            role="alert"
            className="rounded-lg bg-red-50 p-3 text-sm text-red-700"
          >
            {error}
          </p>
        )}
        {notice && (
          <p
            role="status"
            className="rounded-lg bg-emerald-50 p-3 text-sm text-emerald-700"
          >
            {notice}
          </p>
        )}

        <button
          type="submit"
          disabled={loading || code.length < 6}
          className="w-full rounded-lg bg-sky-600 px-4 py-3 font-semibold text-white transition hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-300 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading ? t("confirmingAccount") : t("confirmAccount")}
        </button>
        <button
          type="button"
          onClick={onResend}
          disabled={loading || resending}
          className="w-full text-sm font-medium text-sky-700 underline hover:text-sky-900 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {resending ? t("resendingCode") : t("resendCode")}
        </button>
        <button
          type="button"
          onClick={onBack}
          disabled={loading || resending}
          className="w-full text-sm font-medium text-slate-600 underline hover:text-slate-900 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {t("backToLogin")}
        </button>
      </form>
    </AuthPage>
  );
}
